import { ThemeProvider } from "@mui/material/styles";
import baseTheme from "theme";
import CssBaseline from "@mui/material/CssBaseline";
import { RouterProvider } from "react-router-dom";
import router from "routes";

// 👇 Add this import
import { HelmetProvider } from "react-helmet-async";

const App = () => (
  <HelmetProvider>
    <ThemeProvider theme={baseTheme}>
      <CssBaseline />
      <RouterProvider router={router} />
    </ThemeProvider>
  </HelmetProvider>
);

export default App;
